import {
  appsignal,
  tags as defaultTags,
  // ErrorBoundary as Boundary,
} from '@/crash_reporter';

const Fallback = ({ className = '' }) => (
  <div
    className={`relative z-10 font-medium text-center text-red-600 ${className}`}
  >
    Something wrong, please try again later :(
  </div>
);

export const ErrorBoundary = ({
  children,
  fallComponent: FallComponent,
  fallbackClassName,
  tags = {},
}) => {
  // HACK: if fallComponent uses hooks then it will fail in runtime cause fallback in Boundary renders it conditionally
  // so we render it before Boundary
  const errorElement = FallComponent ? <FallComponent /> : null;
  const errorComponent = errorElement
    ? () => errorElement
    : () => <Fallback className={fallbackClassName} />;
  // return (
  //   <Boundary
  //     instance={appsignal}
  //     tags={{ ...defaultTags, ...tags }}
  //     fallback={errorComponent}
  //   >
  //     {children}
  //   </Boundary>
  // );
  return children;
};
